<template>
  <b-card  no-body :header="name+'流年運勢分析'" class="mb-2" border-variant="primary" header-bg-variant="primary" header-text-variant="white">
    <b-list-group flush>
      <b-list-group-item v-for="(item , index) in listdata" v-bind:key="index">
        <b-row>
          <b-col class="col-4 col-md-2">
            <div  class="primaryGColor text-white rounded p-2 shadow text-center">
              <p class="small my-0 py-0">{{ item.year}}</p>
              <h3 class="my-0 py-0">{{ item.yeardata.result}}</h3>
            </div>
          </b-col>
          <b-col >
            <p >{{ item.yeardata.explantion[0].result}}</p>
          </b-col>
        </b-row>
      </b-list-group-item>
    </b-list-group>
  </b-card>
</template>
<script>

export default {
  name: 'ResultCard',
  props: {
    listdata:Array,
    name:String
  },
  data() {
    return {

    }
  },
  methods: {


  }
}
</script>
